module.exports = __webpack_public_path__ + "static/media/picture-(254).980ac4e5.JPG";